// utils.ts
export const formatNumber = (
    value: number | null | undefined,
    locale: string,
    fractionDigits: number
) => {
    const safeValue = value ?? 0; // Om värdet är null/undefined, sätt det till 0
    return new Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(safeValue);
};


// 🟢 Bestämmer rätt locale baserat på webbläsarens språk
export const detectBestLocale = () => {
    const browserLocale = navigator.language;
    const fallbackLocales: { [key: string]: string } = {
        sv: "sv-SE",
        da: "da-DK",
        nb: "nb-NO",
    };
    return fallbackLocales[browserLocale] || browserLocale; // Konvertera endast om det behövs
};

export const formatWeight = (
    value: number | null | undefined,
    locale: string,
    showUnit: boolean = true,  // Ska "kg" visas?
    fractionDigits: number = 2, // Antal decimaler
    fallback: string = "0" // Vad som ska visas om värdet saknas
) => {
    if (value == null || isNaN(value)) {
        return fallback; // Hanterar null, undefined och NaN
    }

    const formattedNumber = new Intl.NumberFormat(locale, {
        style: 'decimal', // Ingen valutasymbol, bara siffror
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(value);

    return showUnit ? `${formattedNumber} KG` : formattedNumber;
};


